/*
 * Copyright (c) 2026 IntraFi LLC
 */

import { Directive } from '@angular/core';
import { InputFilterBaseDirective } from './input-filter.base.directive';

@Directive({ selector: 'input[pinAlphanumericCode]' })
export class AlphanumericCodeDirective extends InputFilterBaseDirective {
  protected allowedKeyRegex = /^[a-zA-Z0-9]$/;
  protected filterRegex = /[^a-zA-Z0-9]/g; // Remove all non-alphanumeric characters
}
